export default "__VITE_ASSET__gu86HtC___"